export const providerRoles = [
  'Dentist',
  'Dental Hygienist',
  'Dental Therapist',
  'Anesthesiologist',
  'Oral Surgeon',
  'Oral and Maxillofacial Surgeon',
  'Oral Pathologist',
  'Periodontist',
  'Endodontist',
  'Orthodontist',
  'Prosthodontist',
  'Pediatric Dentist',
] as string[]

type AppointedProviderRef = {
  provider_id?: string | null
}

/** First room appointed provider that Scheduling can select. */
export const firstAppointedProviderId = (
  appointedProviders: AppointedProviderRef[] | null | undefined,
  selectableProviderIds: string[],
): string | undefined => {
  if (!appointedProviders?.length || selectableProviderIds.length === 0) {
    return undefined
  }
  const selectable = new Set(selectableProviderIds)
  return (
    appointedProviders.find(
      (provider) =>
        provider.provider_id && selectable.has(provider.provider_id),
    )?.provider_id || undefined
  )
}
